import type { DisbursementsType } from "@/redux/disbursements/disbursementsType";

export const disbursementsReducer = {
  resetDisbursementsError: (state: DisbursementsType) => {
    state.error = null;
  },
  resetDisbursementsSuccess: (state: DisbursementsType) => {
    state.success = null;
  },
  resetApprovalSuccess: (state: DisbursementsType) => {
    state.approvalSuccess = null;
  },
  resetDisbursementsMessage: (state: DisbursementsType) => {
    state.message = null;
  },
  resetApprovalMessage: (state: DisbursementsType) => {
    state.approvalMessage = null;
  },
  resetDisbursementsStatusCode: (state: DisbursementsType) => {
    state.statusCode = null;
  },
  resetDisbursementList: (state: DisbursementsType) => {
    state.disbursementsList = [];
  },
  resetSingleDisbursement: (state: DisbursementsType) => {
    state.singleDisbursement = [];
  },
  resetTotalCount: (state: DisbursementsType) => {
    state.totalCount = 0;
  },
  resetSharedDisbursementList: (state: DisbursementsType) => {
    state.sharedDisbursementList = [];
  },
  resetTotalSharedCount: (state: DisbursementsType) => {
    state.totalSharedCount = 0;
  },
  resetDisbursmentFetching: (state: DisbursementsType) => {
    state.fetching = false;
  },
  resetTotalAmount: (state: DisbursementsType) => {
    state.totalAmount = 0;
  },
  resetRemainingAmount: (state: DisbursementsType) => {
    state.remainingAmount = 0;
  },
};
